
import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Checkbox } from 'antd';
import { LoginContainer, FlexContainer } from './style';
import { Link } from 'react-router-dom';
import history from '../../history';
import { connect } from 'react-redux';
import {resetVerification,resetPassword} from '../../actions/auth';
const PasswordReset = ({resetVerification,resetPassword,location}) => {
    const [token, setToken] = useState(null)
    const [pToken, setPToken] = useState(null)
    useEffect( async () => {
        const search = location.search;
        const token = new URLSearchParams(search).get("token");
        setToken(token)
        const user = new URLSearchParams(search).get("user");
        const res = await resetVerification(token, user)
        setPToken(res)
    }, [])
    const onFinish = (values) => {
        // console.log(getEmail)
        resetPassword(token, pToken, values.password, values.confirm_password)
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    return ( 
        
        <FlexContainer>
            <LoginContainer>
                <img src='./logo.png' />
                <h2 style={{margin: '30px 0px', alignSelf: 'center'}}>Reset Password</h2>
                
                <Form
                name="basic"
                labelCol={{
                    span: 24,
                }}
                wrapperCol={{
                    span: 24,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{width: '100%'}}
                requiredMark={false}
                >
               

                <Form.Item
                    label="New Password"
                    name="password"
                    rules={[
                    {
                        required: true,
                        message: 'Please input your new password!',
                    },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Confirm Password"
                    name="confirm_password"
                    rules={[
                    {
                        required: true,
                        message: 'Please confirm password!',
                    },
                    ]}
                >
                    <Input.Password />
                </Form.Item>


                <Form.Item
                    style={{textAlign: 'center'}}
                >
                    <Button type="primary" htmlType="submit">
                        Reset password
                    </Button>
                </Form.Item>
                <p>Don't have any account ? <Link to="/registration">Register Now</Link></p>
                <p><Link to="/login">Back to Login</Link></p>
                </Form>
            </LoginContainer>
        </FlexContainer>
     );
}
 
export default connect(null,{resetVerification,resetPassword})(PasswordReset);